<script>
    import {createEventDispatcher} from "svelte";
    import {eventBus} from "../core/event-bus-store.js";
    import {t} from "../core/i18n/language-store.js";
    const dispatch = createEventDispatcher();

    export let record;
    export let publishConfig;
    export let tenantKey;

    const addToCartHandler = (record) => {
        if (record?.prices?.length > 1 || record?.mods?.length > 0) {
            eventBus.set([{event: 'openEditDetailsHalfScreen', payload: {record, mode: 'addItems'}}]);
        }
        else {
            dispatch('addToCart', record);
        }
    };

    const removeFromCartHandler = (record) => {
        if (record?.prices?.length > 1 || record?.mods?.length > 0) {
            eventBus.set([{event: 'openEditDetailsHalfScreen', payload: {record, mode: 'removeItems'}}]);
        }
        else {
            dispatch('removeFromCart', record);
        }
    };
</script>
<style>

.record {
    width: 100%;
}
.label {
    background: var(--success-bg-color);
    color: var(--header-background);
    line-height: 1;
    padding: 1px 5px;
    font-size: var(--fs-75);
    font-weight: 600;
    border-top-left-radius: .5rem;
    border-bottom-right-radius: .5rem;
}
.name {
    font-size: var(--fs-110);
    font-weight: 500;
    line-height: 80%;
}
.weight {
    font-size: var(--fs-100);
    color: var(--secondary-font-color);
    font-weight: 500;
}
.price {
    font-size: var(--fs-120);
    font-weight: 500;
}
.price--old {
    font-size: var(--fs-100);
    font-weight: 500;
    text-decoration: line-through;
}
.currency {
    font-size: var(--fs-120);
}
.description {
    padding-right: 2.5rem;
    white-space: pre-wrap;
}
.price-block {
    display: flex;
    flex-direction: column;
    align-items: center;
}
@media (min-width: 768px) {
    .price-block {
        flex-direction: row;
        gap: 0.5em;
    }
}


/*desktop only*/
@media (min-width: 768px) {
    .record:hover {
        background: var(--bg-second-color);
        border-radius: var(--border-radius-xs);
    }
}
</style>

{#if (!record.hidden)}

<div class="record">

    <div class="flex-between ai-center">
        <div>
            {#if (record.label)}
            <span class="label">{ record.label }</span>
            {/if}

            <span class="name">{ record.name }</span>
            {#if (record.prices?.length === 1 && record.prices[0].weight)}
                <span class="weight nowrap">{ record.prices[0].weight }</span>
            {/if}
        </div>
        <div class="flex gap-05 ai-center">
            {#if (record.prices?.length > 0 && record.prices[0]?.price !== null && record.prices[0]?.price !== undefined)}
                <div class="price-block ai-center">

                    {#if (record.prices[0].oldPrice !== undefined)}
                        <span class="price--old">{ record.prices[0].oldPrice }</span>
                    {/if}

                    <span class="nowrap">
                        {#if (record._minPrice !== undefined)}
                            <span>{$t('price.from')} </span>
                            <span class="price price-pair" class:price-pair--rev={publishConfig?.currency === '$'}>
                                <span>{ record._minPrice }</span>
                                <span>{ publishConfig?.currency || '' }</span>
                            </span>
                        {:else}
                            <span class="price price-pair" class:price-pair--rev={publishConfig?.currency === '$'}>
                                <span>{ record.prices[0].price }</span>
                                <span>{ publishConfig?.currency || '' }</span>
                            </span>
                        {/if}
                    </span>

                </div>
            {/if}


            {#if (publishConfig.disableCart !== true)}
                <div class="order-buttons">
                    {#if ( (record?._orderedItems || 0) > 0)}
                        <button class="add-button pointer" on:click|stopPropagation={removeFromCartHandler(record)}>-</button>
                        <span>{record?._orderedItems}</span>
                    {/if}
                    <button class="add-button pointer" on:click|stopPropagation={addToCartHandler(record)}>+</button>
                </div>
            {/if}
        </div>
    </div>

    {#if (record.description)}
        <div class="description">{record.description}</div>
    {/if}

</div>

{/if}
